import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TuneIcon from '@mui/icons-material/Tune';
import FlashOnIcon from '@mui/icons-material/FlashOn';

export const BannerInfoPlanes = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA', // Color de fondo muy suave
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
                    <Box 
                        sx={{ 
                            width: 52, 
                            height: 52, 
                            borderRadius: '50%', 
                            backgroundColor: '#E8E7FD', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >
                        <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                            Gestión de Planes de IA
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                            Administra los planes de suscripción para los servicios de Inteligencia Artificial, definiendo límites, costos y capacidades disponibles.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{sm: 12, md: 4}}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <ListAltIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Información General
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Establece el nombre, código y costo de cada plan de suscripción.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{sm: 12, md: 4}}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <TuneIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Configuración y Límites
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Establece límites de uso mensual, como la cantidad de asistentes, agentes y usuarios permitidos.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{sm: 12, md: 4}}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <FlashOnIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Capacidades
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Habilita funcionalidades específicas (Chat, RAG, Memoria, Audio) para cada nivel de suscripción.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
